export const environment = {
  production: false,
  url: "https://nutrimar.murilosolucoes.com.br/empresa",
  socket_url: "https://nutrimar.murilosolucoes.com.br",
  sincronizarProdutos: false,
};
